export default __webpack_public_path__ + "89326de5de807aebc419fc2db5a60ac9.png";